import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const OurPhilosophy = () => {  
  useEffect(() => {
    document.title = 'Our Philosophy - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>Our Philosophy</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                    <h3>Knowing and Being</h3>
                    <p>At all levels of education we have two major interrelated areas:</p>
                    <ul className="mainlist">
                        <li>The knowing area that deals with facts, techniques, strategies and patterns of thought for mastering
                            subject knowledge.
                            This area is the subject of examinations that leads to paper qualification and career opportunities;
                            and</li>
                        <li>The being area that deals with the way individuals experience their own lives.
                            This area primarily leads to personal maturity and self-realization.</li>
                    </ul>
                    <p>Both these areas are important but unfortunately formal education concentrates almost exclusively upon
                        the knowing area, to the virtual exclusion of the being area.</p>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default OurPhilosophy;
